import { type FC } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@heroui/react";
import { ChevronLeft, ChevronRight } from "@gravity-ui/icons";
import "./HomeExpandToggle.css";

interface HomeExpandToggleProps {
    expanded: boolean;
    onToggle: () => void;
    isDisabled?: boolean;
}

/** Shared expand/collapse toggle for the home tiles - identical across every widget. */
export const HomeExpandToggle: FC<HomeExpandToggleProps> = ({ expanded, onToggle, isDisabled }) => (
    <Button
        size="sm"
        variant="ghost"
        onPress={onToggle}
        isDisabled={isDisabled}
        className="HomeExpandToggle group shrink-0 gap-1 text-xs uppercase tracking-wide opacity-70 transition-all duration-300 hover:opacity-100"
    >
        {!expanded && <ChevronLeft className="size-3.5 transition-transform duration-300 group-hover:-translate-x-1" />}
        <FormattedMessage id={expanded ? "app.home.metrics.collapse" : "app.home.metrics.expand"} />
        {expanded && <ChevronRight className="size-3.5 transition-transform duration-300 group-hover:translate-x-1" />}
    </Button>
);
